import { Link } from "react-router-dom";

import {
  HookFormCheckbox,
  HookFormSelect,
  SubmitButton,
  TextInput,
} from "../../hook-form";
import {
  BulletPoint,
  FormContainer,
  PasswordStrengthIndicator,
  SwitchAppLegalAndContactFooter,
  ToastNotification,
} from "../../components";

import switchAppLogo from "../../assets/images/switchapp-logo.svg";
import bulletIcon from "../../assets/icons/bullet-point.png";
import { ISignupViewProps } from "./SignUp";
import {
  appConstants,
  authValidationConstants,
  countries,
} from "../../constants";
import { SignUpSuccessfulModal } from "./SignUpSuccessfulModal";

export const View = ({
  signUpSuccessful,
  isLoadingResendConfirmationEmail,
  redirectToLogin,
  targetPageOnLogin,
  resendEmailConfirmationLink,
  formValues,
  isPasswordTouched,
  errors: errors,
  handleSubmit: handleSubmit,
  register: register,
}: ISignupViewProps) => {
  const SwitchAppLegalAndContactFooterSignUp = () => (
    <SwitchAppLegalAndContactFooter
      className=""
      sections={[
        {
          linkComponent: "© SwitchApp",
          link_url: appConstants.appWebsiteUrl,
        },
        {
          linkComponent: "Privacy & Terms",
          link_url: appConstants.appPrivacyUrl,
        },
      ]}
    />
  );

  return (
    <>
      <div className="signup-page--container flex-container col justify-content--center align-items--center">
        <div className="flex-container justify-content--center align-items--center">
          {/* {!signUpSuccessful ? null : (
          <div className="toast-notification-container">
            <ToastNotification
              title={"Signup Successful"}
              subtitle={"You have successfully registered on SwitchApp"}
              message={
                "You need to confirm your email address to complete the registration. Please check your email for the confirmation link."
              }
              ariaLabel={"Signup Successful Toast Notification"}
              onClose={redirectToLogin}
            />
          </div>
        )} */}

          <div className="marketting-container">
            <div className="logo-container">
              <Link to="/">
                <img
                  src={switchAppLogo}
                  alt="logo"
                  className="switchapp-logo"
                />
              </Link>
            </div>

            <div className="marketting-text">
              <BulletPoint
                icon={
                  <img
                    src={bulletIcon}
                    alt="bullet point icon"
                    className="bullet-point--icon"
                  />
                }
                title="Get started quickly"
                description="Integrate with developer-friendly APIs or choose low-code or pre-built solutions."
                className="first--bullet"
              />

              <BulletPoint
                icon={
                  <img
                    src={bulletIcon}
                    alt="bullet point icon"
                    className="bullet-point--icon"
                  />
                }
                title="Support any business model"
                description="E-commerce, subscriptions, SaaS platforms, marketplaces, and more—all within a unified platform."
                className="second--bullet"
              />

              <BulletPoint
                icon={
                  <img
                    src={bulletIcon}
                    alt="bullet point icon"
                    className="bullet-point--icon"
                  />
                }
                title="Join other businesses"
                description="SwitchApp is trusted by ambitious startups and enterprises of every size."
                className="third--bullet"
              />
            </div>

            <div className="align-self--end d-none d-md-block">
              <SwitchAppLegalAndContactFooterSignUp />
            </div>
          </div>

          <FormContainer>
            <form onSubmit={handleSubmit}>
              <div className="form-container flex-container col">
                <div className="form-container__header">
                  <h3 className="font-ctm--bold">
                    Create your SwitchApp account
                  </h3>
                </div>

                <div className="form-container__body">
                  <div className="flex-container flex-break--small">
                    <div className="flex-box mr-md-5">
                      <TextInput
                        name="first_name"
                        label="First Name"
                        type="text"
                        register={register}
                        errors={errors}
                      />
                    </div>

                    <div className="flex-box">
                      <TextInput
                        name="last_name"
                        label="Last Name"
                        type="text"
                        register={register}
                        errors={errors}
                      />
                    </div>
                  </div>

                  <div className="flex-container flex-break--small">
                    <div className="flex-box mr-md-5">
                      <TextInput
                        name="email"
                        label="Email"
                        type="email"
                        autoComplete="email"
                        register={register}
                        errors={errors}
                      />
                    </div>

                    <div className="flex-box">
                      <TextInput
                        name="invitation_code"
                        label="Invitation Code"
                        type="text"
                        register={register}
                        errors={errors}
                      />
                    </div>
                  </div>

                  <TextInput
                    name="merchant_name"
                    label="Company Name"
                    type="text"
                    register={register}
                    errors={errors}
                  />

                  <div className="flex-container flex-break--small">
                    <div className="flex-box mr-md-5">
                      <HookFormSelect
                        name="country"
                        label="Country"
                        selectItems={[]}
                        selectGroupedItems={countries}
                        register={register}
                        errors={errors}
                      />
                    </div>
                    <div className="flex-box">
                      <TextInput
                        name="phone_number"
                        label="Phone Number"
                        type="tel"
                        register={register}
                        errors={errors}
                      />
                    </div>
                  </div>

                  <div className="flex-container flex-break--small">
                    <div className="flex-box mr-md-5">
                      <TextInput
                        name="password"
                        label="Password"
                        type="password"
                        register={register}
                        errors={errors}
                        // hideErrorMessage
                      />

                      <PasswordStrengthIndicator
                        password={formValues.password}
                        touched={isPasswordTouched}
                        minimumLength={
                          authValidationConstants.minPasswordLength
                        }
                        // maximumLength={authValidationConstants.maxPasswordLength}
                        validateLowerCase
                        validateUpperCase
                        validateDigitPresent
                        validateSpecialCharacter
                      />
                    </div>
                    <div className="flex-box">
                      <TextInput
                        name="confirm_password"
                        label="Confirm Password"
                        type="password"
                        register={register}
                        errors={errors}
                      />
                    </div>
                  </div>

                  <HookFormCheckbox
                    name="is_consent_checked"
                    label="I agree that SwitchApp may contact me at the email address or phone number above."
                    // className="italic"
                    register={register}
                    errors={errors}
                  />

                  <div className="flex-container buttons-container">
                    <SubmitButton className="flex-box switchapp-themed">
                      Create Merchant Account
                    </SubmitButton>
                  </div>
                </div>
              </div>

              <div className="form-container__footer">
                <p className="">
                  Already have an account?{" "}
                  <Link to={targetPageOnLogin}>Sign In</Link>
                </p>
              </div>

              {/* <div className="form-container__footer">
            <p className="switchapp-legal-agreements">
              By signing up, you agree to the <a href="/terms">Terms</a> and{" "}
              <a href="/privacy">Privacy Policy</a> of SwitchApp Tech Solutions
              Ltd.
            </p>
          </div> */}

              <div className="flex-box switchapp-legal-agreements switchapp-small form-container__footer">
                By creating an account, you agree with the{" "}
                <a href={appConstants.termsAndConditions}>
                  Terms and Conditions
                </a>
                , <a href={appConstants.appPrivacyUrl}>Privacy Policy</a>{" "}
                <br className="line-break--small" />
                and <a href={appConstants.cookiePolicyUrl}>Cookie Policy</a> of
                <b className="company-name font-ctm--bold">
                  {" "}
                  SwitchApp Tech Solutions Limited.
                </b>
              </div>
            </form>
          </FormContainer>

          <div className="legal-and-contact-small d-block d-md-none">
            <SwitchAppLegalAndContactFooterSignUp />
          </div>
        </div>
      </div>

      <SignUpSuccessfulModal
        isModalOpen={signUpSuccessful}
        closeModal={redirectToLogin}
        isLoadingResendConfirmationEmail={isLoadingResendConfirmationEmail}
        resendEmailConfirmationLink={resendEmailConfirmationLink}
      />
    </>
  );
};
